module.exports = __webpack_public_path__ + "img/logo_dark.22f6a4a1.png";